/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Close_MenuInputs */

const en_nav_close_menu = /** @type {(inputs: Nav_Close_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close menu`)
};

const es_nav_close_menu = /** @type {(inputs: Nav_Close_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar menú`)
};

/**
* | output |
* | --- |
* | "Close menu" |
*
* @param {Nav_Close_MenuInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_close_menu = /** @type {((inputs?: Nav_Close_MenuInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Close_MenuInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_close_menu(inputs)
	return en_nav_close_menu(inputs)
});